// Code review - In Progress
// Documentation - In Progress
import React, { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import { BindAPI, BindPostAPI, IUDAPI, parameterPostAPI } from "../services/APIConnection";
import { useUserCapability } from "../components/ConstantReducerProvider";
import DropDown from "../ReusableComponents/DropDown";
import Loader from "../ReusableComponents/Loader";

const DoctorAppoinment = ({
  isOpen,
  clientData,
  data1,
  currentData2,
  doctorPopupCancel,
}) => {

  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;

  const [isLoading, setIsLoading] = useState(false);
  const [apptWith, setApptWith] = useState("");
  const [area, setArea] = useState("");
  const [areaError, setAreaError] = useState("");
  const [meetingLinkError, setMeetingLinkError] = useState("");
  const [meetingLink, setMeetingLink] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editModeFlag, setEditModeFlag] = useState(1);

  const [apptWithError, setApptWithError] = useState("");


  const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now.getDate().toString().padStart(2, "0");
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const [appointmentDate, setappointmentDate] = useState(getCurrentDate);
  const [appointmentEndDateTime, setAppointmentEndDateTime] = useState("");
  const [appointmentStartDateTime, setAppointmentStartDateTime] = useState("");

  const [apptBranchMailId, setApptBranchMailId] = useState("");
  const [branchMailIdDD, setBranchMailIdDD] = useState([]);
  const [disableBranchMailId, setDisableBranchMailId] = useState(true);

  useEffect(() => {
    const appoinmentWithDD = async () => {
      const data = {
        mstOrganizationStructureId: userProfileDatas[0]?.MstOrganizationId,
        mstBranchId: userProfileDatas[0]?.MstLocationId,
        mstSdpId: userProfileDatas[0]?.MstSDPId
          ? userProfileDatas[0]?.MstSDPId
          : null,
        mstUserId: userProfileDatas[0]?.MstUserId,
        mstRoleId: userProfileDatas[0]?.MstRoleId,
        languageCode: "en",
      };
      const locationResponse = await BindPostAPI([data], "LocationAPI/GetLocation");

      if (userProfileDatas[0]?.MstLocationId) {
        const filteredData = locationResponse.data.Table.filter(
          (item) => item.MstLocationId === userProfileDatas[0].MstLocationId
        );
        const emailKeys = ['Email', 'Email1', 'Email2'];
        const locationData = filteredData[0]; // <-- get the object from the array

        const emailOptions = emailKeys
          .map(key => locationData[key])
          .filter(email => email !== null && email !== undefined && email !== '')
          .filter((email, index, self) => self.indexOf(email) === index)
          .map(email => ({ value: email, label: email }));

        console.log(emailOptions);

        setBranchMailIdDD(emailOptions);
        if (emailOptions.length === 1) {
          setApptBranchMailId(emailOptions[0].value);
        }
        else if (currentData2.TxnServicesId == null && emailOptions.length > 1) {
          setApptBranchMailId(emailOptions[0].value);
          setDisableBranchMailId(false);
        }
        else {
          setApptBranchMailId(emailOptions[0].value);
          setDisableBranchMailId(false);
        }
        //   setApptBranchMailId(filteredData[0].Email);
        setApptWith(userProfileDatas[0].MstLocationId);


      }

      if (currentData2 && currentData2[0]) {
        setappointmentDate(currentData2[0].AppoinmentDate);
        setApptWith(userProfileDatas[0].MstLocationId);
        setArea(currentData2[0].MstAreaId);
        setMeetingLink(currentData2[0].MeetingLink);
        setApptBranchMailId("");
        setApptBranchMailId(currentData2[0].AppointmentEmail);
        setEditMode(true);
      } else {
        setappointmentDate(getCurrentDate);
        handleEndTime(appointmentDate);
        if (userProfileDatas && userProfileDatas[0]) {
          if (userProfileDatas[0].MstLocationId != null) {
            setApptWith(userProfileDatas[0].MstLocationId);
          } else {
            setApptWith("");
          }
        }
        setArea("");
        setMeetingLink("");
      }
    };
    appoinmentWithDD();
  }, [userProfileDatas, currentData2 ? currentData2 : undefined]);



  const validate = () => {
    // Initialize an object to store validation errors for each field
    const errors = {};

    // Validation logic for the Appoinment With input
    if (apptWith == "") {
      errors.apptWith = "Select Appoinment With";
    }



    setApptWithError(errors.apptWith || "");

    return errors;
  };

  // const handleSubmit = () => {

  //   if (meetingLink != "") {
  //     const appoinmentPayload = {
  //       appointmentDate: appointmentDate,
  //       AppointmentWith: apptWith,
  //       AppointmentEmail: apptBranchMailId,
  //       MstAreaId: area,
  //       MeetingLink: meetingLink,
  //       Status: editModeFlag ? editModeFlag : "",
  //     };
  //     data1(appoinmentPayload);
  //     isOpen(false);
  //   }
  // };

  useEffect(() => {
    if (doctorPopupCancel) {
      setappointmentDate(getCurrentDate);
      setApptWith("");
      setApptWithError("");
      setArea("");
      setAreaError("");
      setMeetingLink("");
      setApptBranchMailId("");
      setMeetingLinkError("");
      setEditMode(false);
    }
  }, [doctorPopupCancel ? doctorPopupCancel : false]);
  const handleValueChange = (value) => {
    setEditModeFlag(value);
  };



  const handleEndTime = (selectedDate) => {
    const selectedDateObj = new Date(selectedDate);
    const endTime = new Date(
      new Date(selectedDate).getTime() + 2 * 60 * 60 * 1000
    ); // Add 2 hours
    setAppointmentEndDateTime(endTime.toISOString().slice(0, 16)); // Convert to ISO string and remove seconds
    setAppointmentStartDateTime(selectedDateObj.toISOString().slice(0, 16));
  };

  const ScheduleAppointment = async () => {
    setIsLoading(true)
    let validation = validate();
    if (Object.keys(validation).length === 0) {
      let payload = {
        subject: `Doctor Appointment - ${clientData?.ClientName_en}`,
        body: { contentType: "HTML", content: "" },
        start: { dateTime: appointmentStartDateTime, timeZone: "UTC" },
        end: { dateTime: appointmentEndDateTime, timeZone: "UTC" },
        location: { displayName: "Online" },
        attendees: [
          {
            emailAddress: {
              address: userProfileDatas[0]?.UserEmail,
              name: userProfileDatas[0]?.UserName,
            },
            type: "required",
          },
          {
            emailAddress: { address: apptBranchMailId, name: "" },
            type: "required",
          },
        ],
        isOnlineMeeting: true,
        onlineMeetingProvider: "teamsForBusiness",

        //  lobbyBypassSettings : 
        // {
        //     scope : "everyone"   // Everyone joins directly (no lobby)
        // }
      };

      const response = await IUDAPI(
        payload,
        "api/MicrosoftTeamsAPI/CreateMicrosoftTeamsMeeting"
      );

      if (response.status === 200) {
        const regExp = /Join URL:\s*(https:\/\/teams\.microsoft\.com\/[^\s]+)/;
        const match = response?.data?.match(regExp);

        if (match && match[1]) {
          const joinUrl = match[1];
          setMeetingLink(joinUrl);

          const appoinmentPayload = {
            appointmentDate: appointmentDate,
            AppointmentWith: apptWith,
            AppointmentEmail: apptBranchMailId,
            MstAreaId: area,
            MeetingLink: joinUrl,
            Status: editModeFlag ? editModeFlag : "",
          };
          data1(appoinmentPayload);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (!appointmentDate) return;

    data1({
      appointmentDate: appointmentDate,   // match DB/API field name exactly
      AppointmentWith: apptWith,
      AppointmentEmail: apptBranchMailId,
      MstAreaId: area,
      MeetingLink: meetingLink,
      Status: editModeFlag ? editModeFlag : "",
    });
  }, [appointmentDate, apptWith, apptBranchMailId, area, meetingLink]);

  return (

    <div class="w-full">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      <div>
        <form class={"p-5"}>
          <div class={mainTable.labelBold}>Doctor Appointment</div>
          <hr class={mainTable.servicesHorizontalLine}></hr>
          <div className="md:grid gap-4 mb-6 md:grid-cols-2 lg:grid-cols-4 sm:col-span-1 w-full">
            <InputText
              inputType="datetime-local"
              title="Appoinment Date"
              name="date"
              tabIndex="1"
              min={new Date().toISOString().slice(0, 16)}
              content={appointmentDate}
              // controlFunc={(e) => {
              //   setappointmentDate(e.target.value);
              //   if (
              //     editMode &&
              //     currentData2[0].AppoinmentDate != e.target.value
              //   ) {
              //     handleValueChange(2);
              //   }
              // }}

              controlFunc={(e) => {
                setappointmentDate(e.target.value);
                handleEndTime(e.target.value); // keep start/end datetime in sync with the new date

                if (editMode && currentData2[0].AppoinmentDate != e.target.value) {
                  handleValueChange(2);
                  setMeetingLink("");
                }
              }}
            />

            <InputText
              inputType="text"
              title={"Appointment with"}
              tabIndex="1"
              name={"CYPConversionFactor"}
              content={userProfileDatas[0]?.LocationName_en}
              disabled="true"
            />
            {/* <InputText
              inputType="text"
              disabled="true"
              title={"Branch / Project Email"}
              content={apptBranchMailId}
              name={"CYPConversionFactor"}
            /> */}
            <DropDown

              tabIndex="1"

              title="Branch / Project Email"
              placeholder="Select"
              disabled={disableBranchMailId}
              options={branchMailIdDD}
              selectedOption={apptBranchMailId}
              controlFunc={(e) => {
                setApptBranchMailId(e.target.value);
                setMeetingLink("");

              }}
              name={"CYPConversionFactor"}
            />
            <div className="mt-7 mr-7">
              <button
                type="button"
                tabIndex={1}
                className={
                  meetingLink === ""
                    ? mainTable.submitButton
                    : mainTable.disabledSubmitButton
                }
                onClick={() => {
                  ScheduleAppointment();
                }}
                disabled={meetingLink === "" ? false : true}
                title={meetingLink === "" ? "" : "Button is disabled"}
              >
                Schedule Appoinment
              </button>
            </div>
          </div>
          {meetingLink != "" && (
            <div class="lg:col-span-4 sm:col-span-1">
              <TextArea
                inputType="text"
                title="Your Meeting Link"
                name="meetingLink"
                rows={4}
                placeholder="Meeting Link"
                content={meetingLink}
                disabled="true"
              />
            </div>
          )}
        </form>

      </div>
    </div>
  );
};

export default DoctorAppoinment;
